/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'cip',
  template: require('./cip.component.html')
})

export class CipComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
    this.firstName = this.appActions.getData('YourInformation.firstName');
    this.lastName = this.appActions.getData('YourInformation.lastName');
  }

  validateForm() {
    const errorObj = { hasErrors: false, errorCount: 0 }
    _.forEach(this.form.inputs, (radio) => {
      const value = this.appActions.getData(radio.inputPath);
      if (value == null) {
        errorObj.hasErrors = true;
        errorObj.errorCount += 1;
      }

    });
    this.flowManager.pageError = errorObj;
    return !errorObj.hasErrors;
  }

  btnClick(e) {
    if (this.flowManager.isSubmittingDAPI !== true) {
      this.formValid = this.validateForm();
      if (this.formValid === true) {
        this.flowManager.isSubmittingDAPI = true;
        this.modal.loadingModel();
        const payload = this.appActions.getState();
        this.appProxy.verifyKBA(payload, resp => {
          this.flowManager.isSubmittingDAPI = false;
          this.flowManager.completedCipForm = true;
          this.appActions.deleteData('review./cip');
          this.modal.closeModal();
          this.handleClick(e.action);
        });
      }
    }
  }
}
